import { axiosPut } from 'shared/api/axios'
import { apiUrls } from 'consts'
import displayGenError from 'shared/utils/displayGenError'
import Store from 'redux/Store'
import { setMessage } from 'redux/actions'
import { AxiosError } from 'axios'

interface handleToggleVisibilityProps {
  id: string
  setShowOverlay: Function
  setRowActionsClickCount: Function
}

const handleToggleVisibility = async (props: handleToggleVisibilityProps) => {
  props.setShowOverlay(true)

  let response: any = false

  const catchFunc = (err: AxiosError) => {
    displayGenError({ setShowOverlay: props.setShowOverlay })
  }

  response = await axiosPut(
    apiUrls.deviceTableConfig + '/' + props.id + '/' + apiUrls.actionToggle,
    {},
    catchFunc,
  )

  if (response?.status === 200) {
    Store.dispatch(setMessage('Column visibility successfully changed.', 'success', 'instant'))
    props.setRowActionsClickCount((prevValue) => prevValue + 1)
  }
  props.setShowOverlay(false)
}

export default handleToggleVisibility
